import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogHeaderComponent } from './dialog-header.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    DialogHeaderComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
  ],
  exports: [
    DialogHeaderComponent,
  ]
})
export class DialogHeaderModule { }
